/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconReceipt2 = createReactComponent("receipt-2", "IconReceipt2", [
  [
    "path",
    {
      d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M14 8h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5m2 0v1.5m0 -9v1.5",
      key: "svg-1"
    }
  ]
]);

export { IconReceipt2 as default };
//# sourceMappingURL=IconReceipt2.js.map
